import { createContext } from 'react';
export const DiscussionContext = createContext(undefined);
//# sourceMappingURL=DiscussionContext.js.map